import styles from '@components/Modal/styles.module.scss';
import { modalCancelableAtom } from '@states/uiAtoms';
import { useAtomValue } from 'jotai/index';
import {
  ReactNode, useEffect, useRef,
} from 'react';
import { createPortal } from 'react-dom';

interface Props {
    isOpen: boolean;
    close: () => void;
    // title?: string;
    children?: ReactNode;
    // footerDirection?: 'row' | 'column-reverse';
    // confirmText?: string;
    // confirmDisabled?: boolean;
    // onConfirm?: () => void;
    // cancelDisabled?: boolean;
    // cancelText?: string;
    // containerClassName?: string;
}

function ModalComponent(props: Props) {
  const {
    isOpen, close, children,
  } = props;
  const bgRef = useRef<HTMLDivElement>(null);
  const cancelable = useAtomValue(modalCancelableAtom);

  /*
  const handleConfirm = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    close();
    // onConfirm?.();
  };

   */

  useEffect(() => {
    if (isOpen) {
      bgRef.current?.classList.remove(styles.none);
      const showTimeout = setTimeout(() => {
        bgRef.current?.classList.remove(styles.hide);
      }, 50);
      return () => clearTimeout(showTimeout);
    }
    bgRef.current?.classList.add(styles.hide);
    const closeTimeout = setTimeout(() => {
      bgRef.current?.classList.add(styles.none);
    }, 200);
    return () => clearTimeout(closeTimeout);
  }, [isOpen]);

  return (<div ref={bgRef}
                 className={`${styles.background} ${styles.none} ${styles.hide}`}
                 onClick={() => {
                   if (cancelable) {
                     close();
                   }
                 }}>

        <div className={styles.container}
             onClick={(e) => {
               e.preventDefault();
               e.stopPropagation();
             }} >
            {children}
            {/*
            {title && (
                <Text size='xl'
                      fontWeight='bold'
                      className={styles.title}>
                    {title}
                </Text>
            )}
            <Column spacing={28}
                    align='center'
                    fullWidth>
                {children}
                <footer className={styles.footer}
                        style={{ flexDirection: footerDirection }}>
                    {(!cancelDisabled) && (
                        <Button variant='secondary'
                                fullWidth
                                size='sm'
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  close();
                                }}>
                            {cancelText ?? '취소'}
                        </Button>
                    )
                    }
                    {onConfirm && (
                        <Button size='sm'
                                fullWidth
                                disabled={confirmDisabled}
                                onClick={handleConfirm}>
                            {confirmText ?? '확인'}
                        </Button>
                    )}
                </footer>
            </Column>
*/}
        </div>
    </div>);
}

function Modal(props: Props) {
  return createPortal(<ModalComponent {...props} />, document.body);
}

export default Modal;
